import { BaseEntity } from "src/app/tools/models/baseEntity";


export class LoyaltyProgram extends BaseEntity{
    
    loyaltyProgramCode    : string;
    name            : string;
    rank            : number;
    color           : string;

}
